var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      attrs: {
        visible: _vm.drawer,
        direction: "rtl",
        size: "50%",
        "modal-append-to-body": false,
        "before-close": _vm.handleClose,
        title: _vm.title,
      },
      on: {
        "update:visible": function ($event) {
          _vm.drawer = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "send-email-drawer-content" },
        [
          _vm.drawer
            ? _c(
                "el-form",
                {
                  ref: "form",
                  staticClass: "send-email-form",
                  staticStyle: { padding: "16px" },
                  attrs: {
                    "label-position": "top",
                    model: _vm.form,
                    disabled: _vm.disabled,
                    rules: _vm.rules,
                    "label-width": "160px",
                  },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SendEmail.table.EmailTitle"),
                                prop: "mailTitle",
                              },
                            },
                            [
                              _c("BjInput", {
                                attrs: {
                                  maxlength: _vm.MAX_LENGTH.BILLMAX,
                                  placeholder: _vm.$t("inputText"),
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.form.mailTitle,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "mailTitle", $$v)
                                  },
                                  expression: "form.mailTitle",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SendEmail.table.EmailContent"),
                                prop: "content",
                              },
                            },
                            [
                              _c("BjInput", {
                                attrs: {
                                  type: "textarea",
                                  rows: 16,
                                  "show-word-limit": "",
                                  maxlength: 2000,
                                  placeholder: _vm.$t("inputText"),
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.form.content,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "content", $$v)
                                  },
                                  expression: "form.content",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SendEmail.table.EmailType"),
                                prop: "emailType",
                              },
                            },
                            [
                              _c("BjSelectLov", {
                                attrs: {
                                  "option-list": _vm.emailTypeList,
                                  clearable: false,
                                },
                                on: { change: _vm.changeCustomerType },
                                model: {
                                  value: _vm.form.emailType,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "emailType", $$v)
                                  },
                                  expression: "form.emailType",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("SendEmail.table.Multiples"),
                              },
                            },
                            [
                              _c(
                                "UploadFile",
                                {
                                  ref: "UploadFileRef",
                                  staticClass: "avatar-uploader",
                                  attrs: {
                                    limit: 20,
                                    "limit-size": 5 * 1024,
                                    multiple: "",
                                    "show-file-list": "",
                                    accept:
                                      "image/png,image/jpeg,.csv,.pdf,.doc,.docx,.xlsx",
                                    "accept-list": [
                                      "image/jpeg",
                                      "image/png",
                                      ".csv",
                                      ".pdf",
                                      ".doc",
                                      ".xlsx",
                                    ],
                                    "auto-upload": "",
                                    "limit-hide": "",
                                  },
                                  on: {
                                    handleFileListChange: _vm.fileListChange,
                                  },
                                },
                                [
                                  _c(
                                    "template",
                                    { slot: "default" },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "small",
                                            type: "primary",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "BusinessImportHistory.page.SelectFile"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "SendEmail.table.RequireConfirmation"
                                ),
                                prop: "requireConfirmation",
                              },
                            },
                            [
                              _c("el-switch", {
                                attrs: {
                                  "active-value": 1,
                                  "inactive-value": 0,
                                },
                                model: {
                                  value: _vm.form.requireConfirmation,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "requireConfirmation",
                                      $$v
                                    )
                                  },
                                  expression: "form.requireConfirmation",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "send-email-footer" },
            [
              _c(
                "el-button",
                { attrs: { type: "danger" }, on: { click: _vm.handleClose } },
                [_vm._v(_vm._s(_vm.$t("cancelText")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: _vm.disabled },
                  on: { click: _vm.handleConfirm },
                },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }